// @flow
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

type mrType = {
  _id?: string;
  _mrLogin?: string;
};

@Injectable()
export class MrService {
  static parameters = [HttpClient];
  constructor(private http: HttpClient) {
    this.http = http;
  }

  query(): Observable<mrType[]> {
    return this.http.get('/api/manufacturers/') as Observable<mrType[]>;
  }
  get(user: mrType = { _id: 'me', _mrLogin: 'MR' }): Observable<mrType> {
    return this.http.get(
      `/api/manufacturers/${user._id}`
    ) as Observable<mrType>;
  }
}
